//
//
//
//
//
//
//
//
//
//
//
//
//
//

// TODO: Make this component smart, so it forces the needed properties in order to avoid conceptual issues
export default {
  name: 'rb-board-with-fields-below-stacked-mobile',
  props: {
    slidesPerViewDesktop: {
      type: Number,
      default: 3,
    },
    slidesPerViewTablet: {
      type: Number,
      default: 3,
    },
    slidesPerViewMobile: {
      type: Number,
      default: 1,
    },
    columnsOfNextSlide: {
      type: Number,
      default: 5,
    },
    fullScreenMobile: {
      type: Boolean,
      default: true,
    },
  },
}
